export const ReportIcon = () => {
  return (
    <svg fill="none" height="16" viewBox="0 0 13 16" width="13" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 4.8L8.125 0H1.625C1.19402 0 0.780698 0.168571 0.475951 0.468629C0.171205 0.768687 0 1.17565 0 1.6V14.4C0 14.8243 0.171205 15.2313 0.475951 15.5314C0.780698 15.8314 1.19402 16 1.625 16H11.375C11.806 16 12.2193 15.8314 12.524 15.5314C12.8288 15.2313 13 14.8243 13 14.4V4.8ZM4.0625 13.6H2.4375V6.4H4.0625V13.6ZM7.3125 13.6H5.6875V8.8H7.3125V13.6ZM10.5625 13.6H8.9375V11.2H10.5625V13.6ZM8.125 5.6H7.3125V1.6L11.375 5.6H8.125Z"
        fill="#0056B8"
      />
    </svg>
  );
};
